var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kircWrapper", attrs: { id: "kirc" } },
    [
      _c("div", { staticClass: "particles" }),
      _vm._v(" "),
      _vm.kirc
        ? _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-5\n        md-medium-size-10\n        md-small-size-100\n        md-xsmall-size-100\n      "
              },
              [
                _vm.showResult
                  ? _c(
                      "md-button",
                      {
                        staticClass: "md-fab",
                        on: {
                          click: function($event) {
                            _vm.showResult = false
                          }
                        }
                      },
                      [_c("md-icon", [_vm._v("arrow_back")])],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-80\n        md-medium-size-95\n        md-small-size-95\n        md-xsmall-size-100\n      "
              },
              [
                !_vm.showResult
                  ? _c(
                      "md-card",
                      { staticClass: "mainFormCard md-elevation-16" },
                      [
                        _c("md-card-header", [
                          _c("div", { staticClass: "headlineWrapper" }, [
                            _c("div", { staticClass: "md-layout" }, [
                              _c(
                                "div",
                                { staticClass: "md-layout-item md-size-50" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-display-2 mainHeadline"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  KI-Readiness-Check\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "md-layout-item md-size-50",
                                  attrs: { align: "right" }
                                },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "Secondary md-raised",
                                      attrs: { to: "/readinesscheck/res" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "buttonText" },
                                        [_vm._v(" Ergebnis laden ")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-card-content",
                          [
                            _c(
                              "md-steppers",
                              {
                                attrs: {
                                  id: "kircStepper",
                                  "md-vertical": "",
                                  "md-active-step": _vm.active
                                },
                                on: {
                                  "update:mdActiveStep": function($event) {
                                    _vm.active = $event
                                  },
                                  "update:md-active-step": function($event) {
                                    _vm.active = $event
                                  }
                                }
                              },
                              _vm._l(_vm.kirc.categories, function(
                                item,
                                catid
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: item.name,
                                    attrs: { item: item, index: catid }
                                  },
                                  [
                                    _c(
                                      "md-step",
                                      {
                                        attrs: {
                                          "md-label": item.name,
                                          id: item.name
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.scrollToTop()
                                          }
                                        }
                                      },
                                      [
                                        _vm._l(item.questions, function(
                                          question,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            { key: question.name },
                                            [
                                              !question.archived
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "questionWrapper"
                                                    },
                                                    [
                                                      question.name ==
                                                      "In welcher Branche ist Ihr Unternehmen tätig?"
                                                        ? _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      index +
                                                                        1 +
                                                                        ". " +
                                                                        question.name
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "\n                            md-layout-item\n                            md-size-150\n                            md-medium-size-120\n                            md-small-size-100\n                            md-xsmall-size-100\n                            answerBoxes\n                            drop\n                          ",
                                                                attrs: {
                                                                  id:
                                                                    "largeDropdown"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "md-field",
                                                                  {
                                                                    staticClass:
                                                                      "\n                            md-layout-item\n                            md-size-100\n                            md-medium-size-100\n                            md-small-size-100\n                            md-xsmall-size-100\n                          "
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-select",
                                                                      {
                                                                        staticStyle: {
                                                                          width:
                                                                            "100% !important",
                                                                          "min-width":
                                                                            "100%"
                                                                        },
                                                                        attrs: {
                                                                          name:
                                                                            "industry",
                                                                          id:
                                                                            "industry",
                                                                          placeholder:
                                                                            "Branche",
                                                                          "md-dense":
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .kircinstance
                                                                              .categories[
                                                                              catid
                                                                            ]
                                                                              .questions[
                                                                              index
                                                                            ]
                                                                              .answers[0]
                                                                              .input,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .kircinstance
                                                                                .categories[
                                                                                catid
                                                                              ]
                                                                                .questions[
                                                                                index
                                                                              ]
                                                                                .answers[0],
                                                                              "input",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "kircinstance.categories[catid].questions[index].answers[0].input"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.industries,
                                                                        function(
                                                                          key
                                                                        ) {
                                                                          return _c(
                                                                            "md-option",
                                                                            {
                                                                              key: key,
                                                                              staticStyle: {
                                                                                width:
                                                                                  "100% !important",
                                                                                "min-width":
                                                                                  "100%"
                                                                              },
                                                                              attrs: {
                                                                                value: key
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  key
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        : question.name ==
                                                            "Wie lautet die Postleitzahl Ihres Unternehmens?" ||
                                                          question.name ==
                                                            "Wo ist ihr Unternehmen zu Hause?"
                                                        ? _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      index +
                                                                        1 +
                                                                        ". Wo ist Ihr Unternehmen zu Hause?"
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("h5", [
                                                              _vm._v(
                                                                "Diese Angaben sind optional"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "md-layout md-gutter md-alignment-top-left"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "\n                            md-layout-item\n                            md-size-50\n                            md-medium-size-50\n                            md-small-size-100\n                            md-xsmall-size-100\n                          "
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-field",
                                                                      [
                                                                        _c(
                                                                          "label",
                                                                          [
                                                                            _vm._v(
                                                                              "Ihre Postleitzahl:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "md-input",
                                                                          {
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .kircinstance
                                                                                  .categories[
                                                                                  catid
                                                                                ]
                                                                                  .questions[
                                                                                  index
                                                                                ]
                                                                                  .answers[0]
                                                                                  .input,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .kircinstance
                                                                                    .categories[
                                                                                    catid
                                                                                  ]
                                                                                    .questions[
                                                                                    index
                                                                                  ]
                                                                                    .answers[0],
                                                                                  "input",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "\n                                kircinstance.categories[catid].questions[index].answers[0].input\n                              "
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : question.name ==
                                                          "Bitte geben Sie Ihre E-Mail-Adresse an, wenn Sie die Ergebnisse des KI-Readiness-Checks zusätzlich per Mail erhalten möchten."
                                                        ? _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      index +
                                                                        1 +
                                                                        ". " +
                                                                        question.name
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("h5", [
                                                              _vm._v(
                                                                "Diese Angaben sind optional"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "md-layout md-gutter md-alignment-top-left"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "\n                            md-layout-item\n                            md-size-50\n                            md-medium-size-50\n                            md-small-size-100\n                            md-xsmall-size-100\n                          "
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-field",
                                                                      [
                                                                        _c(
                                                                          "label",
                                                                          [
                                                                            _vm._v(
                                                                              "Ihre E-Mail-Adresse:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "md-input",
                                                                          {
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .kircinstance
                                                                                  .categories[
                                                                                  catid
                                                                                ]
                                                                                  .questions[
                                                                                  index
                                                                                ]
                                                                                  .answers[0]
                                                                                  .input,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .kircinstance
                                                                                    .categories[
                                                                                    catid
                                                                                  ]
                                                                                    .questions[
                                                                                    index
                                                                                  ]
                                                                                    .answers[0],
                                                                                  "input",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "\n                                kircinstance.categories[catid].questions[index].answers[0].input\n                              "
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      index +
                                                                        1 +
                                                                        ". " +
                                                                        question.name
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "md-layout md-gutter md-alignment-top-left"
                                                              },
                                                              [
                                                                question.answers
                                                                  .length > 11
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "\n                            md-layout-item\n                            md-size-60\n                            md-medium-size-50\n                            md-small-size-100\n                            md-xsmall-size-100\n                            answerBoxes\n                            drop\n                          ",
                                                                        attrs: {
                                                                          id:
                                                                            "largeDropdown"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            attrs: {
                                                                              hint:
                                                                                _vm.Antwort,
                                                                              items:
                                                                                question.answers,
                                                                              "item-text":
                                                                                "text",
                                                                              "item-value":
                                                                                "text",
                                                                              label:
                                                                                "Antwort",
                                                                              "persistent-hint":
                                                                                "",
                                                                              density:
                                                                                "compact",
                                                                              width:
                                                                                "100%",
                                                                              "min-width":
                                                                                "100%",
                                                                              "max-width":
                                                                                "100%",
                                                                              "single-line":
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .kircinstance
                                                                                  .categories[
                                                                                  catid
                                                                                ]
                                                                                  .questions[
                                                                                  index
                                                                                ]
                                                                                  .answers[0]
                                                                                  .input,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .kircinstance
                                                                                    .categories[
                                                                                    catid
                                                                                  ]
                                                                                    .questions[
                                                                                    index
                                                                                  ]
                                                                                    .answers[0],
                                                                                  "input",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "\n                              kircinstance.categories[catid].questions[index].answers[0].input \n                            "
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._l(
                                                                      question.answers,
                                                                      function(
                                                                        answer
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              answer.text,
                                                                            staticClass:
                                                                              "\n                            md-layout-item\n                            md-size-20\n                            md-medium-size-20\n                            md-small-size-100\n                            md-xsmall-size-100\n                            answerBoxes\n                          "
                                                                          },
                                                                          [
                                                                            (answer.name ==
                                                                              "keine Antwort möglich" ||
                                                                              answer.name ==
                                                                                "Keine der angegebenen Möglichkeiten.") &&
                                                                            question.type ==
                                                                              "multiple" // || question.type == 'single')
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    on: {
                                                                                      change: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.deselect(
                                                                                          catid,
                                                                                          index
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance
                                                                                          .categories[
                                                                                          catid
                                                                                        ]
                                                                                          .questions[
                                                                                          index
                                                                                        ]
                                                                                          .answers,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance
                                                                                            .categories[
                                                                                            catid
                                                                                          ]
                                                                                            .questions[
                                                                                            index
                                                                                          ],
                                                                                          "answers",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance.categories[catid].questions[index].answers"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : answer.name !=
                                                                                  "Freitextantwort" &&
                                                                                question.type ==
                                                                                  "multiple" // || question.type == 'single')
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    on: {
                                                                                      change: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.removeDeselect(
                                                                                          catid,
                                                                                          index
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance
                                                                                          .categories[
                                                                                          catid
                                                                                        ]
                                                                                          .questions[
                                                                                          index
                                                                                        ]
                                                                                          .answers,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance
                                                                                            .categories[
                                                                                            catid
                                                                                          ]
                                                                                            .questions[
                                                                                            index
                                                                                          ],
                                                                                          "answers",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance.categories[catid].questions[index].answers"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : answer.name !=
                                                                                  "Freitextantwort" &&
                                                                                (question.type ==
                                                                                  null ||
                                                                                  question.type ==
                                                                                    "single")
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance
                                                                                          .categories[
                                                                                          catid
                                                                                        ]
                                                                                          .questions[
                                                                                          index
                                                                                        ]
                                                                                          .answers[0],
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance
                                                                                            .categories[
                                                                                            catid
                                                                                          ]
                                                                                            .questions[
                                                                                            index
                                                                                          ]
                                                                                            .answers,
                                                                                          0,
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance.categories[catid].questions[index].answers[0]"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.text
                                                                                      ) +
                                                                                        "\n                          "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : (question.type ==
                                                                                  "free" ||
                                                                                  ((answer.name =
                                                                                    "Freitextantwort") &&
                                                                                    question.type ==
                                                                                      null)) &&
                                                                                _vm
                                                                                  .kircinstance
                                                                                  .categories[
                                                                                  catid
                                                                                ]
                                                                                  .questions[
                                                                                  index
                                                                                ]
                                                                                  .answers[0] !=
                                                                                  null
                                                                              ? _vm._l(
                                                                                  _vm
                                                                                    .kircinstance
                                                                                    .categories[
                                                                                    catid
                                                                                  ]
                                                                                    .questions[
                                                                                    index
                                                                                  ]
                                                                                    .answers,
                                                                                  function(
                                                                                    answerInstance
                                                                                  ) {
                                                                                    return _c(
                                                                                      "md-field",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              answerInstance.name ==
                                                                                              "Sonstige*",
                                                                                            expression:
                                                                                              "\n                                answerInstance.name ==\n                                'Sonstige*'\n                              "
                                                                                          }
                                                                                        ],
                                                                                        key:
                                                                                          answerInstance.hash
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "label",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Antwort"
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "md-input",
                                                                                          {
                                                                                            model: {
                                                                                              value:
                                                                                                _vm
                                                                                                  .kircinstance
                                                                                                  .categories[
                                                                                                  catid
                                                                                                ]
                                                                                                  .questions[
                                                                                                  index
                                                                                                ]
                                                                                                  .answers[0]
                                                                                                  .input,
                                                                                              callback: function(
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  _vm
                                                                                                    .kircinstance
                                                                                                    .categories[
                                                                                                    catid
                                                                                                  ]
                                                                                                    .questions[
                                                                                                    index
                                                                                                  ]
                                                                                                    .answers[0],
                                                                                                  "input",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                              expression:
                                                                                                "\n                                kircinstance.categories[catid].questions[index].answers[0].input\n                              "
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          2
                                                                        )
                                                                      }
                                                                    ),
                                                                _vm._v(" "),
                                                                _c("br"),
                                                                _vm._v(" "),
                                                                question.help !=
                                                                null
                                                                  ? _c(
                                                                      "CircleTooltip",
                                                                      {
                                                                        attrs: {
                                                                          text:
                                                                            question.help
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              2
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        catid == 4
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "confirmationWrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-accent md-raised nextBtn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setDone(
                                                              catid
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "KIRC Abschließen"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-switch",
                                                  {
                                                    model: {
                                                      value: _vm.forTesting,
                                                      callback: function($$v) {
                                                        _vm.forTesting = $$v
                                                      },
                                                      expression: "forTesting"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Dies ist ein Testlauf"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "confirmationWrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-accent md-raised nextBtn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setDone(
                                                              catid
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Weiter")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.error &&
                            _vm.error !=
                              "Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>"
                              ? _c("div", {
                                  staticClass: "missedQuestions",
                                  domProps: { innerHTML: _vm._s(_vm.error) }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showProgress
                              ? _c("md-progress-bar", {
                                  staticClass: "md-accent",
                                  attrs: { "md-mode": "indeterminate" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showResult
                  ? _c(
                      "md-card",
                      [
                        _c("md-card-content", [
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-left"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-left"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stickyHeading__Wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-display-1 kiReadinessLevel__H1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Ergebnisse\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-divider")
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "md-card",
                                    {
                                      staticClass: "CustomCard md-elevation-4"
                                    },
                                    [
                                      _c("md-card-content", [
                                        _c(
                                          "div",
                                          { staticClass: "stars-wrapper" },
                                          [
                                            _vm.level >= 1
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level >= 2
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level >= 3
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level >= 4
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level >= 5
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level < 2
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level < 3
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level < 4
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level < 5
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.level < 0.8
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "progress-wrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "finalScoreWrapper"
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "levelSubheading"
                                                  },
                                                  [_vm._v("Level")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h1",
                                                  {
                                                    staticClass: "mb-2",
                                                    attrs: { id: "finalScore" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level + "/5"
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.level === 1
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level1.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 2
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level2.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 3
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level3.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 4
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level4.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 5
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level5.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 1 && false
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level1.text
                                                            ) +
                                                            " \n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 2 && false
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level2.text
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 3 && false
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level3.text
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 4 && false
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level4.text
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.level === 5 && false
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level5.text
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _vm.resulttoken
                                                  ? _c(
                                                      "p",
                                                      {
                                                        attrs: {
                                                          slot: "textCard__Text"
                                                        },
                                                        slot: "textCard__Text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                       Bitte notieren Sie sich Ihren "
                                                        ),
                                                        _c("strong", [
                                                          _vm._v("Ergebniscode")
                                                        ]),
                                                        _vm._v(": "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.resulttoken
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-60 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c("TextCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "textCard__Icon" },
                                        slot: "textCard__Icon"
                                      },
                                      [_vm._v("compare_arrows")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "textCard__Headline" },
                                        slot: "textCard__Headline"
                                      },
                                      [
                                        _vm._v(
                                          "Vergleich zu anderen Unternehmen"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "textCard__Text" },
                                        slot: "textCard__Text"
                                      },
                                      [
                                        _vm.levelIndustry &&
                                        _vm.levelIndustry > 0.8
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "block"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Andere Unternehmen Ihrer Branche haben durchschnittlich"
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  " einen KI-Readiness-Level von "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.levelIndustry
                                                      ) + " Sternen."
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "stars-wrapper"
                                                  },
                                                  [
                                                    _vm.levelIndustry >= 1
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry >= 2
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry >= 3
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry >= 4
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry >= 5
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry < 2
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry < 3
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry < 4
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry < 5
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelIndustry < 0.9
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                       erreicht.\n                  "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "block"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Es gibt nicht genügend Unternehmen in Ihrer Branche, um einen Vergleich zu ziehen.\n                  "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm.levelSize && _vm.levelSize > 0.2
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "block"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Andere Unternehmen Ihrer Größe haben durchschnittlich"
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  " einen KI-Readiness-Level von "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.levelSize) +
                                                        " Sternen "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "stars-wrapper"
                                                  },
                                                  [
                                                    _vm.levelSize >= 1
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize >= 2
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize >= 3
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize >= 4
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize >= 5
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize < 2
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize < 3
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize < 4
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize < 5
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.levelSize < 0.9
                                                      ? _c("img", {
                                                          staticClass:
                                                            "star-small",
                                                          attrs: {
                                                            src: require("../../../assets/star_gray.svg"),
                                                            alt: "Star",
                                                            width: "15",
                                                            height: "15"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    erreicht.\n                  "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "block"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Es gibt nicht genügend Unternehmen in Ihrer Unternehmensgröße, um einen Vergleich zu ziehen.\n                  "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Basiert auf Auswertung von insgesamt " +
                                                _vm._s(
                                                  _vm.amountCompaniesComparison
                                                ) +
                                                " Unternehmen."
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-80 md-medium-size-80 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stickyHeading__Wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-display-1 kiReadinessLevel__H1"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Empfehlungen nach Reifegrad"
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-divider")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.rec, function(item, key) {
                                    return _c(
                                      "md-card",
                                      { key: key, staticClass: "TextCard" },
                                      [
                                        _c(
                                          "md-card-header",
                                          { staticClass: "TextCard__Wrapper" },
                                          [
                                            _c(
                                              "md-card-header-text",
                                              {
                                                staticClass: "TextCard__Header"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-title rectitle",
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "IconBox",
                                                        staticStyle: {
                                                          "margin-right": "40px"
                                                        }
                                                      },
                                                      [
                                                        key === "Leude"
                                                          ? _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          human\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        key === "Menschen"
                                                          ? _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          person\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : key ===
                                                            "Technologie"
                                                          ? _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          settings\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : key === "Umwelt"
                                                          ? _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          map\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : key ===
                                                            "Organisation"
                                                          ? _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          domain\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "IconBox__Icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          home\n                        "
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("h5", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(key) +
                                                          "\n                      "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "stars-wrapper",
                                                        staticStyle: {
                                                          "margin-left": "40px",
                                                          width: "100%",
                                                          "text-align": "right",
                                                          display: "flex-end",
                                                          "justify-content":
                                                            "flex-end",
                                                          float: "right",
                                                          clear: "both"
                                                        }
                                                      },
                                                      [
                                                        _vm.subLevels[key] >= 1
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] >= 2
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] >= 3
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] >= 4
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] >= 5
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] < 2
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] < 3
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] < 4
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] < 5
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.subLevels[key] < 0.8
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.isVisibleCat(key)
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "collapse-button",
                                                                attrs: {
                                                                  icon:
                                                                    "$chevron-down"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleCat(
                                                                      key
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "collapse-icon",
                                                                    attrs: {
                                                                      color:
                                                                        "#FFFFFF"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-chevron-down"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isVisibleCat(key)
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "collapse-button",
                                                                attrs: {
                                                                  icon:
                                                                    "$chevron-up"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleCat(
                                                                      key
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "collapse-icon",
                                                                    attrs: {
                                                                      color:
                                                                        "#FFFFFF"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-chevron-up"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isVisibleCat(key)
                                          ? _c(
                                              "md-card-content",
                                              {
                                                staticClass: "TextCard__Content"
                                              },
                                              _vm._l(
                                                _vm.answerInstances,
                                                function(question, akey) {
                                                  return key ===
                                                    question.category &&
                                                    question.score > 0.1 &&
                                                      question.score < 5.2
                                                    ? _c(
                                                        "div",
                                                        { key: akey },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "md-layout md-gutter md-alignment-center-center"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    visibility:
                                                                      "hidden"
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        question.score
                                                                      ) + "/5"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "md-layout-item reifegrad"
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        question.maturityCriteria
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      question.score
                                                                    ) + " / 5"
                                                                  )
                                                                ])
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "md-layout md-gutter md-alignment-top-center recommendation_container"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "md-layout-item recommendation"
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle: {
                                                                          "font-weight":
                                                                            "bold"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Statusbericht: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          question.kircResText
                                                                        )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "md-layout-item recommendation"
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle: {
                                                                          "font-weight":
                                                                            "bold"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Empfehlung: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          question.rec
                                                                        )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("md-divider", {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "10px",
                                                              "margin-bottom":
                                                                "10px"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.recEvents.length > 0
                                    ? _c("RecCard", [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "recCard__Icon" },
                                            slot: "recCard__Icon"
                                          },
                                          [_vm._v("calendar_today")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              slot: "recCard__Headline"
                                            },
                                            slot: "recCard__Headline"
                                          },
                                          [_vm._v("Events")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "recCard__Content" },
                                            slot: "recCard__Content"
                                          },
                                          [
                                            _c(
                                              "md-table",
                                              _vm._l(_vm.recEvents, function(
                                                recevent,
                                                index
                                              ) {
                                                return _c(
                                                  "md-table-row",
                                                  { key: index.recevent },
                                                  [
                                                    _c("md-table-cell", [
                                                      _vm._v(
                                                        _vm._s(recevent.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("md-table-cell", [
                                                      _vm._v(
                                                        _vm._s(
                                                          recevent.eventdate
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("md-table-cell", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: recevent.link,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "md-accent eventBtn"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Mehr Dazu\n                            "
                                                              ),
                                                              _c("md-icon", [
                                                                _vm._v(
                                                                  "arrow_right_alt"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.recEvents.length == 0
                                    ? _c("RecCard", [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "recCard__Icon" },
                                            slot: "recCard__Icon"
                                          },
                                          [_vm._v("calendar_today")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              slot: "recCard__Headline"
                                            },
                                            slot: "recCard__Headline"
                                          },
                                          [_vm._v("Events")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "recCard__Content" },
                                            slot: "recCard__Content"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Derzeit können wir für Ihr Ergebnis leider keine\n                  Empfehlungen anzeigen\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.recTrainer.length > 0
                                    ? _c("RecCard", [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "recCard__Icon" },
                                            slot: "recCard__Icon"
                                          },
                                          [_vm._v("people")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              slot: "recCard__Headline"
                                            },
                                            slot: "recCard__Headline"
                                          },
                                          [_vm._v("KI-Trainer")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "recCard__Content" },
                                            slot: "recCard__Content"
                                          },
                                          [
                                            _c(
                                              "md-table",
                                              _vm._l(_vm.recTrainer, function(
                                                rectrainer,
                                                index
                                              ) {
                                                return _c(
                                                  "md-table-row",
                                                  { key: index.rectrainer },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass: "no-link",
                                                        attrs: {
                                                          to:
                                                            "/trainerdetail/" +
                                                            rectrainer.hash,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "md-table-cell",
                                                          {
                                                            staticClass:
                                                              "ki-cell-small"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                rectrainer.name
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "md-table-cell",
                                                          {
                                                            staticClass:
                                                              "ki-cell-small"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                rectrainer.competence_center
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "md-table-cell",
                                                          {
                                                            staticClass:
                                                              "ki-cell-large"
                                                          },
                                                          _vm._l(
                                                            rectrainer.main_emphases,
                                                            function(
                                                              mainemphases,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "v-chip",
                                                                {
                                                                  key:
                                                                    index.mainemphases,
                                                                  staticClass:
                                                                    "ma-1",
                                                                  attrs: {
                                                                    small: "",
                                                                    chip: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      mainemphases.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.recTrainer.length == 0
                                    ? _c("RecCard", [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "recCard__Icon" },
                                            slot: "recCard__Icon"
                                          },
                                          [_vm._v("people")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              slot: "recCard__Headline"
                                            },
                                            slot: "recCard__Headline"
                                          },
                                          [_vm._v("KI-Trainer")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "recCard__Content" },
                                            slot: "recCard__Content"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Derzeit können wir für Ihr Ergebnis leider keine\n                  Empfehlungen anzeigen\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-card-actions",
                          { staticClass: "resultAction-Wrapper" },
                          [
                            !_vm.loggedIn
                              ? _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised text-align-left md-primary CTA CTA--newCheck",
                                    attrs: { to: "/readiness-welcome" }
                                  },
                                  [
                                    _c("span", { staticClass: "buttonText" }, [
                                      _vm._v("Neuer Check")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "\n        md-layout-item\n        md-size-5\n        md-medium-size-10\n        md-small-size-100\n        md-xsmall-size-100\n      "
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "\n      md-layout-item\n      md-size-5\n      md-medium-size-10\n      md-small-size-100\n      md-xsmall-size-100\n    "
      }),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003eff36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003eff36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/KIRC2.vue
// module id = null
// module chunks = 